<nb-tabset>
    <nb-tab *ngIf="usersRol.GESTIONAR_REPARACIONES_DEBITOS" tabTitle="Débitos/Pagos" responsive>
        <div class="row">
            <div>
                <nb-select size="tiny" id="operadorDebitos"
                placeholder="Seleccionar Operador"
                [(ngModel)]="operadorProcesadoDebitos"
                (ngModelChange)="capturarOperadorDebitos()">
                <nb-option *ngFor="let ope of operador" value="{{ope.id}}">{{ope.descripcion}}</nb-option>
                </nb-select>
            </div>
        
            <div>
                <mat-form-field style="margin-left: 8px; margin-top: -13px;">
                    <mat-label>Fecha Desde</mat-label>
                    <input matInput [matDatepicker]="picker1" disabled (ngModelChange)="changeDesdeDebito($event)" [(ngModel)]="desdeDebito" name="DesdeDebito">
                    <mat-datepicker-toggle matSuffix [for]="picker1">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="margin-left: 8px; margin-top: -13px;">
                    <mat-label>Fecha Hasta</mat-label>
                    <input matInput [matDatepicker]="picker2" disabled (ngModelChange)="changeHastaDebito($event)" [(ngModel)]="hastaDebito" name="HastaDebito">
                    <mat-datepicker-toggle matSuffix [for]="picker2">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div style="margin-left: 8px;">
                <button nbButton size="tiny" class=" buttontz" (click)="fillGrillaDebitos()" [disabled]="deshabilitarBuscarDebito" >Buscar</button>
                <button nbButton shape="round" size="small float-right"  class="btn-ayuda" (click)="openDialog()">
                    <nb-icon nbPrefix icon="question-mark-circle-outline"></nb-icon>
                  </button>
            </div>
        </div>
            <app-spinner *ngIf="showSpinner"></app-spinner>
                <div *ngIf="cargarGrillaDebitos">
                <!-- <angular-slickgrid
                gridId="gridReparacionesDebitos"
                (sgOnClick)="onCellClickedDebitos($event.detail.eventData, $event.detail.args)"
                [columnDefinitions]="columnDefinitionsReparacionesDebitos"
                [gridOptions]="gridOptionsReparacionesDebitos"
                [dataset]="datasetReparacionesDebitos"
                gridHeight="380"
                gridWidth="100%"
                (onAngularGridCreated)="angularGridReadyDebitos($event)">
                </angular-slickgrid> -->
                <ag-grid-angular
                    #grilla1
                    class="ag-theme-alpine"
                    style="width: 100%; height: 380px;"
                    [rowData]="datasetReparacionesDebitos"
                    [columnDefs]="columnDefinitionsReparacionesDebitos"
                    [overlayNoRowsTemplate]="''"
                    (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>

            </div>
        <app-spinner *ngIf="showSpinnerGuardarDebito" style="float: right; margin-top: 5px;"></app-spinner>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;" class=" buttontz" [disabled]="deshabilitarExportDeb" (click)="exportToExcelDebitos()"><nb-icon icon="save-outline"></nb-icon>Exportar</button>
        <button *ngIf="!showSpinnerGuardarDebito" nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz" (click)="openActualizarDebitos()" [disabled]="deshabilitarActualizarDebito">Actualizar</button>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;"  class="buttontz" (click)="openGuardarDebito()" [disabled]="deshabilitarGuardarDebito">Guardar</button>
    </nb-tab>
    <nb-tab *ngIf="usersRol.GESTIONAR_REPARACIONES_SEGUROS" tabTitle="Seguros" responsive>
        <div class="row">
            <div>
                <nb-select size="tiny" id="operadorSeguro"
                placeholder="Seleccionar Operador"
                [(ngModel)]="operadorProcesadoSeguros"
                (ngModelChange)="capturarOperadorSeguros()">
                <nb-option *ngFor="let ope of operador" value="{{ope.id}}">{{ope.descripcion}}</nb-option>
                </nb-select>
            </div>
            <div>
                <mat-form-field style="margin-left: 8px; margin-top: -13px;">
                    <mat-label>Fecha Desde</mat-label>
                    <input matInput [matDatepicker]="picker3" disabled (ngModelChange)="changeDesdeSeguro($event)" [(ngModel)]="desdeSeguro" name="DesdeSeguro">
                    <mat-datepicker-toggle matSuffix [for]="picker3">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker3 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="margin-left: 8px; margin-top: -13px;">
                    <mat-label>Fecha Hasta</mat-label>
                    <input matInput [matDatepicker]="picker4"  disabled (ngModelChange)="changeHastaSeguro($event)" [(ngModel)]="hastaSeguro" name="hastaSeguro">
                    <mat-datepicker-toggle matSuffix [for]="picker4">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker4 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div style="margin-left: 8px;">
                <button nbButton size="tiny" class=" buttontz" (click)="buscarSeguros()" [disabled]="deshabilitarBuscarSeguro" >Buscar</button>
                <button nbButton shape="round" size="small float-right"  class="btn-ayuda" (click)="openDialogSeguros()">
                    <nb-icon nbPrefix icon="question-mark-circle-outline"></nb-icon>
                  </button>
            </div>
        </div>
            <app-spinner *ngIf="showSpinner"></app-spinner>
            <!-- <angular-slickgrid *ngIf="cargarGrillaSeguros"
            gridId="gridReparacionesSeguros"
            (sgOnClick)="onCellClickedSeguros($event.detail.eventData, $event.detail.args)"
            [columnDefinitions]="columnDefinitionsReparacionesSeguros"
            [gridOptions]="gridOptionsReparacionesSeguros"
            [dataset]="datasetReparacionesSeguros"
            gridHeight="380"
            gridWidth="100%"
            (onAngularGridCreated)="angularGridReadySeguros($event)">
            </angular-slickgrid> -->
            <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetReparacionesSeguros"
            [columnDefs]="columnDefinitionsReparacionesSeguros"
            [overlayNoRowsTemplate]="''"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>

        <app-spinner *ngIf="showSpinnerGuardarSeguro" style="float: right; margin-top: 5px;"></app-spinner>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;" class=" buttontz" [disabled]="deshabilitarExportSeg" (click)="exportToExcelSeguros()"><nb-icon icon="save-outline"></nb-icon>Exportar</button>
        <button *ngIf="!showSpinnerGuardarSeguro" nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz" (click)="openActualizarSeguros()" [disabled]="deshabilitarActualizarSeguro">Actualizar</button>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;"  class="buttontz" (click)="openGuardarSeguros()" [disabled]="deshabilitarGuardarSeguro">Guardar</button>
    </nb-tab>
</nb-tabset>